<script setup>
import { computed } from 'vue';
import {
  splitLocalDateTime,
  toIsoDateTime,
} from '../helper/dateRangeFilterHelper';

const props = defineProps({
  modelValue: {
    type: [String, Array],
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);

const normalizedValue = computed(() => {
  if (Array.isArray(props.modelValue)) {
    return props.modelValue[0] || '';
  }

  return props.modelValue || '';
});

const parseDateTime = splitLocalDateTime;
const combineDateTime = (date, time) => toIsoDateTime(date, time);

const dateValue = computed({
  get: () => parseDateTime(normalizedValue.value).date,
  set: value => {
    const { time } = parseDateTime(normalizedValue.value);
    emit('update:modelValue', combineDateTime(value, time));
  },
});

const timeValue = computed({
  get: () => parseDateTime(normalizedValue.value).time,
  set: value => {
    const { date } = parseDateTime(normalizedValue.value);
    emit('update:modelValue', combineDateTime(date, value));
  },
});
</script>

<template>
  <div class="flex items-center gap-1 min-w-0">
    <input
      v-model="dateValue"
      type="date"
      class="block min-w-0 flex-1 h-8 py-1.5 px-2 text-sm reset-base outline outline-1 outline-n-weak rounded-lg bg-n-alpha-black2 text-n-slate-12"
    />
    <input
      v-model="timeValue"
      type="time"
      class="block w-28 shrink-0 h-8 py-1.5 px-2 text-sm reset-base outline outline-1 outline-n-weak rounded-lg bg-n-alpha-black2 text-n-slate-12"
    />
  </div>
</template>
